import { Select } from "@madhive/kit-ui";
import { AVAILABLE_AI_AGENTS } from "@madhive/mad-sdk";
import { SelectAgentProps } from "./types";

const options = [...AVAILABLE_AI_AGENTS];

/**
 * Component for selecting an AI agent from the available options.
 * It uses the Select component from kit-ui and is designed to work with the list of agents provided by the mad-sdk.
 */
function SelectAgent({ value, onChange, ...props }: SelectAgentProps) {
  return (
    <Select
      label="Select Agent"
      hideLabel
      cannotClear
      options={options}
      value={value}
      lookupId={v => v}
      lookupLabel={v => v}
      {...props}
      onChange={agent => onChange(agent)}
    />
  );
}

export default SelectAgent;
